import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useDiscussionNavigation = (projectId, discussionId, config) => {
  return useQuery({
    ...config,
    queryKey: ["discussion-navigation", projectId, discussionId],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/discussions/${discussionId}/navigation`,
        signal,
      });
    },
  });
};
